/* src/app/features/recuperacao/recuperacao-credito/recuperacao-credito-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=recuperacao-credito-detalhe.component.css.map */
